module.exports = __webpack_public_path__ + "img/bar.a85d3a05.png";